<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="tenantId"-->
        <!--          label="租户ID"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.tenantId" />-->
        <!--        </a-form-model-item>-->
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="serialNo"
          label="设备编号"
        >
          <a-input placeholder="请输入设备编号" v-model="model.serialNo" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="cameraName"
          label="安装位置"
        >
          <a-input placeholder="请输入安装位置" v-model="model.cameraName" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="actionArea"
          label="学校名称"
        >
          <a-input placeholder="请输入学校名称" v-model="model.actionArea" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="areaType"
          label="位置类型"
        >
          <a-input-number
            placeholder="请输入位置类型(0=默认、1=入校、2=出校)"
            v-model="model.areaType"
          />
        </a-form-model-item>
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="delFlag"-->
        <!--          label="删除标志位"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.delFlag" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="regId"-->
        <!--          label="7500注册返回ID"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.regId" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="subscriptionUrl"-->
        <!--          label="订阅地址"-->
        <!--        >-->
        <!--          <a-input placeholder="请输入订阅地址" v-model="model.subscriptionUrl" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="subscriptionId"-->
        <!--          label="订阅号"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.subscriptionId" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="surveillanceId"-->
        <!--          label="布控号"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.surveillanceId" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="threshold"-->
        <!--          label="布控相似度阀值"-->
        <!--        >-->
        <!--          <a-input-number v-model="model.threshold" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="ip" label="ip">-->
        <!--          <a-input placeholder="请输入ip" v-model="model.ip" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="username"-->
        <!--          label="username"-->
        <!--        >-->
        <!--          <a-input placeholder="请输入username" v-model="model.username" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--          prop="password"-->
        <!--          label="password"-->
        <!--        >-->
        <!--          <a-input placeholder="请输入password" v-model="model.password" />-->
        <!--        </a-form-model-item>-->
        <!--        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="port" label="port">-->
        <!--          <a-input-number v-model="model.port" />-->
        <!--        </a-form-model-item>-->
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import moment from 'moment'

export default {
  name: 'GdCameraModal',
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },

      confirmLoading: false,
      validatorRules: {
        areaType: [{ required: true, message: '请输入位置类型(0=默认、1=入校、2=出校)!' }],
      },
      url: {
        add: '/gdCamera/add',
        edit: '/gdCamera/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-input-number {
  width: 100% !important;
}
</style>
